// src/pages/dashboardadmindata/expand/blognewsrecipeexpand.jsx
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector }            from "react-redux";
import Chart                                   from "chart.js/auto";
import Modal                                   from "react-bootstrap/Modal";
import { Card, CardBody }                      from "../../../components/card/card.jsx";

import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";
import "datatables.net-responsive-bs5/css/responsive.bootstrap5.min.css";

import {
  fetchAdminBlogNewsStats,
  fetchAdminBlogStatisticsAdditionalData
} from "../../../actions/dashboardadmin_actions";

const $ = require("jquery");
$.DataTable = require("datatables.net");
require("datatables.net-bs5");
require("datatables.net-responsive");
require("datatables.net-responsive-bs5");

const BlognewsRecipeExpand = React.memo(() => {
  const dispatch       = useDispatch();
  const chartRef       = useRef(null);
  const summaryRef     = useRef(null);
  const modalRef       = useRef(null);

  var themeColor = getComputedStyle(document.body)
    .getPropertyValue("--bs-theme")
    .trim();



  const [show, setShow]           = useState(false);
  const [dateLabel, setDateLabel] = useState("");

  // Redux slices
  const {
    blogNewsStats,
    loadingBlogNewsStats,
    blogNewsStatsError,
    blogStatisticsAdditionalData,
    loadingBlogStatisticsAdditionalData,
    blogStatisticsAdditionalDataError
  } = useSelector(state => ({
    blogNewsStats:                   state.dashboardadmin.blogNewsStats,
    loadingBlogNewsStats:            state.dashboardadmin.loadingBlogNewsStats,
    blogNewsStatsError:              state.dashboardadmin.blogNewsStatsError,
    blogStatisticsAdditionalData:    state.dashboardadmin.blogStatisticsAdditionalData,
    loadingBlogStatisticsAdditionalData:
      state.dashboardadmin.loadingBlogStatisticsAdditionalData,
    blogStatisticsAdditionalDataError:
      state.dashboardadmin.blogStatisticsAdditionalDataError
  }));

  // 1) Fetch summary on mount
  useEffect(() => {
    const now = Math.floor(Date.now() / 1000);
    dispatch(fetchAdminBlogNewsStats(0, now));
  }, [dispatch]);

  // 2) Chart
  useEffect(() => {
    if (!chartRef.current || !blogNewsStats.dateswise) return;
    const labels = blogNewsStats.dateswise.map(d => d.label);
    const values = blogNewsStats.dateswise.map(d => d.value);

    const chart = new Chart(chartRef.current, {
      type: "line",
      data: {
        labels,
        datasets: [{
          label: "Blog Views Over Time",
          data: values,
          borderColor: themeColor,
          pointBorderColor: themeColor,
          pointBackgroundColor:"#fff",
          backgroundColor: "rgba(0,123,255,0.2)",
          borderWidth: 1.5,
          fill: false,
          pointRadius: 4
        }]
      },
      options: { responsive: true, maintainAspectRatio: false }
    });
    return () => chart.destroy();
  }, [blogNewsStats]);

  // 3) Summary table
  useEffect(() => {
    if (!summaryRef.current) return;
    const data = [...(blogNewsStats.dateswise || [])].reverse();

    const dt = $(summaryRef.current).DataTable({
      data,
      columns: [
        { title: "#",    data: null,
          render: (_d,_t,_r,meta) => meta.row + 1
        },
        { title: "Date",  data: "label" },
        { title: "Count", data: "value" },
        {
          title: "Details",
          data:  null,
          render: (_d,_t,row) =>
            `<button class="btn btn-primary btn-sm view-details"
                     data-row='${JSON.stringify(row)}'>View</button>`
        }
      ],
      destroy:    true,
      responsive: true
    });

    $(summaryRef.current)
      .off("click", ".view-details")
      .on("click", ".view-details", function() {
        const row = $(this).data("row");
        const [, start, end] = row.Details
          .match(/\(([^,]+),([^,]+),([^)]+)\)/).slice(1);

        setDateLabel(row.label);
        dispatch(fetchAdminBlogStatisticsAdditionalData(+start, +end));
        setShow(true);
      });

    return () => dt.destroy();
  }, [blogNewsStats, dispatch]);

  // 4) Modal table
  useEffect(() => {
    if (!modalRef.current) return;

    const dt = $(modalRef.current).DataTable({
      data: blogStatisticsAdditionalData || [],
      columns: [
        { title: "ID",         data: "id" },
        { title: "News Title", data: "news.title" },
        { title: "View Count", data: "news.viewcount" },
        {
          title: "Created",
          data:  "created",
          render: ts => {
            const d = new Date(ts * 1000);
            return d.toLocaleString("en-US", {
              month:   "2-digit",
              day:     "2-digit",
              year:    "numeric",
              hour:    "2-digit",
              minute:  "2-digit",
              second:  "2-digit",
              hour12:  true
            });
          }
        },
        {
          title: "Updated",
          data:  "updated",
          render: ts => {
            const d = new Date(ts * 1000);
            return d.toLocaleString("en-US", {
              month:   "2-digit",
              day:     "2-digit",
              year:    "numeric",
              hour:    "2-digit",
              minute:  "2-digit",
              second:  "2-digit",
              hour12:  true
            });
          }
        }
      ],
      destroy:    true,
      responsive: true
    });

    return () => dt.destroy();
  }, [blogStatisticsAdditionalData]);



  return (
    <>
      <h1>Blog News Stats</h1>

      {/* Chart */}
      <section className="accordion mb-3" id="accordionSummary">
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button className="accordion-button" data-bs-toggle="collapse" data-bs-target="#collapseChart">
              Chart Over Time
            </button>
          </h2>
          <div id="collapseChart" className="accordion-collapse collapse show">
            <div className="accordion-body" style={{ height: '400px', overflow: 'hidden' }}>
              <canvas ref={chartRef} className="w-100" height="450" />
            </div>
          </div>
        </div>

        {/* Summary Table */}
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button className="accordion-button" data-bs-toggle="collapse" data-bs-target="#collapseTable">
              Details Over Time
            </button>
          </h2>
          <div id="collapseTable" className="accordion-collapse collapse show">
            <div className="accordion-body">
              <div className="table-responsive">
                <table ref={summaryRef} className="table table-striped w-100" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Modal */}
      <Modal show={show} fullscreen onHide={() => setShow(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Blog Details – {dateLabel}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Card>
            <CardBody>
              {loadingBlogStatisticsAdditionalData && <div className="spinner-border" />}
              {blogStatisticsAdditionalDataError && (
                <div className="text-danger">{blogStatisticsAdditionalDataError}</div>
              )}
              {!loadingBlogStatisticsAdditionalData && !blogStatisticsAdditionalDataError && (
                <div className="table-responsive">
                  <table ref={modalRef} className="table table-striped w-100" />
                </div>
              )}
            </CardBody>
          </Card>
        </Modal.Body>
      </Modal>
    </>
  );
});

export default BlognewsRecipeExpand;
